import React from "react";
import { ErrorBoundary } from "../../ErrorBoundary";
import { useTheme } from "../../../Hooks";
function LeftSection({ children, simplebar, height }) {
    const { theme } = useTheme();

    return (
        <div
            className='bootsrapiso'
            style={{
                width: `100%`,
                background: "white",
                overflowY: "scroll",
                overflowX: "hidden",
                minHeight: simplebar ? `80vh` : height || `calc(100vh - 160px)`,
            }}
        >
            <div style={{ background: "white", height: "15%" }}>
                <ErrorBoundary>{children[0]}</ErrorBoundary>
            </div>
            <div style={{ background: `white`, height: "85%" }}>
                <ErrorBoundary>{children[1]}</ErrorBoundary>
            </div>
        </div>
    );
}
export default LeftSection;

